// Skip to main content functionality
(function () {
	function waitForElement(selector, callback, maxAttempts = 50) {
		var element = document.querySelector(selector);
		if (element) {
			callback(element);
			return;
		}

		var attempts = 0;
		var interval = setInterval(function () {
			element = document.querySelector(selector);
			if (element) {
				clearInterval(interval);
				callback(element);
			} else if (++attempts >= maxAttempts) {
				clearInterval(interval);
			}
		}, 100);
	}

	function setupSkipButton(buttonId, targetSelector) {
		var button = document.getElementById(buttonId);
		if (button) {
			button.addEventListener('click', function (e) {
				e.preventDefault();
				waitForElement(targetSelector, function (element) {
					element.focus();
				});
			});
		}
	}

	// Wait for DOM to be ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			setupSkipButton('skipToMainContent', '#appContent');
			setupSkipButton('skipToSidebarNavigation', '.navigation-sidebar');
			setupSkipButton('skipToTopNavigationBar', '#topNav');
		});
	} else {
		// DOM is already ready
		setupSkipButton('skipToMainContent', '#appContent');
		setupSkipButton('skipToSidebarNavigation', '.navigation-sidebar');
		setupSkipButton('skipToTopNavigationBar', '#topNav');
	}
})();
